import { useMonitor } from '../use-monitor';

export function useMonitorFinishActionSubmit() {
  return useMonitor('finish-action-submit');
}
